export const state = () => ({
  transparent: false,
  whiteStyle: true,
  iconWhite: false,
});

export const mutations = {
  setNav(_state, opt = { transparent: false, whiteStyle: false, iconWhite: false }) {
    console.trace("---", opt.whiteStyle);
    _state.whiteStyle = opt.whiteStyle;
    _state.transparent = opt.transparent;
    _state.iconWhite = opt.iconWhite;
  },
};



// WEBPACK FOOTER //
// ./src/store/nav.js